module.exports = __webpack_public_path__ + "img/26.ad50178e.jpg";